import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import AdminLayout from './AdminLayout';
import { AdminDashboard } from './AdminDashboard';
import { ProfileManagement } from './ProfileManagement';
import { AchievementsManagement } from './AchievementsManagement';
import { EducationManagement } from './EducationManagement';
import { CourseManagement } from './CourseManagement';
import { CertificateManagement } from './CertificateManagement';
import { GalleryManagement } from './GalleryManagement';
import { MediaLibrary } from './MediaLibrary';
import AnalyticsDashboard from './AnalyticsDashboard';

import WorksheetManager from './WorksheetManager';
import ContactManager from './ContactManager';

export const AdminRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Admin login route */}
      <Route path="login" element={<ProtectedRoute />} />
      
      {/* Protected admin routes */}
      <Route path="*" element={<ProtectedRoute />}>
        <Route element={<AdminLayout />}>
          {/* Dashboard */}
          <Route index element={<AdminDashboard />} />
          
          {/* Profile Management */}
          <Route path="profile" element={<ProfileManagement />} />
          
          {/* Achievements Management */}
          <Route path="achievements" element={<AchievementsManagement />} />
          
          {/* Education Management */}
          <Route path="education" element={<EducationManagement />} />
          
          {/* Course Management */}
          <Route path="courses" element={<CourseManagement />} />
          
          {/* Certificate Management */}
          <Route path="certificates" element={<CertificateManagement />} />
          
          {/* Gallery Management */}
          <Route path="gallery" element={<GalleryManagement />} />
          
          {/* Media Library */}
          <Route path="media" element={<MediaLibrary />} />
          

          
          {/* Worksheets Management */}
          <Route path="worksheets" element={<WorksheetManager />} />
          
          {/* Contact Management */}
          <Route path="contact" element={<ContactManager />} />
          
          {/* Analytics Dashboard */}
          <Route path="analytics" element={<AnalyticsDashboard />} />
          
          {/* Redirect unknown admin routes to dashboard */}
          <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
        </Route>
      </Route>
    </Routes>
  );
};